import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useT } from "@/lib/i18n";
import { api, errMsg } from "@/lib/api";
import { AuthShell, inputCls, btnCls } from "./Login";
import { PasswordInput } from "@/components/PasswordInput";

export function ForgotPassword() {
  const { t } = useT();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/auth/forgot-password", { email, origin_url: window.location.origin }); setSent(data); } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title={t("forgot_title")} footer={<Link to="/login" data-testid="back-login-link" className="font-semibold text-[#4a8a56]">{t("back_login")}</Link>}>
      {sent ? (
        <div data-testid="forgot-sent" className="space-y-3 text-sm text-slate-700">
          <p>{t("forgot_sent")}</p>
          {sent.dev_token && <a data-testid="forgot-dev-link" href={`${window.location.origin}/reset-password?token=${sent.dev_token}`} className="block break-all rounded-xl bg-amber-50 p-3 text-xs text-amber-800">{t("forgot_dev_note")}<br /><span className="font-mono underline">{`${window.location.origin}/reset-password?token=${sent.dev_token}`}</span></a>}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm text-slate-600">{t("forgot_desc")}</p>
          <input data-testid="forgot-email-input" type="email" required placeholder={t("email")} className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          <button data-testid="forgot-submit-btn" disabled={busy} className={btnCls}>{t("forgot_submit")}</button>
        </form>
      )}
    </AuthShell>
  );
}

export function ResetPassword() {
  const { t } = useT();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pwd !== pwd2) return setErr(t("pwd_mismatch"));
    setBusy(true);
    try { await api.post("/auth/reset-password", { token: params.get("token"), password: pwd }); toast.success(t("reset_ok")); nav("/login"); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title={t("reset_title")} footer={<Link to="/login" className="font-semibold text-[#4a8a56]">{t("back_login")}</Link>}>
      <form onSubmit={submit} className="space-y-4">
        <PasswordInput testId="reset-password-input" required minLength={6} placeholder={t("new_password")} value={pwd} onChange={(e) => setPwd(e.target.value)} />
        <PasswordInput testId="reset-password2-input" required minLength={6} placeholder={t("confirm_password")} value={pwd2} onChange={(e) => setPwd2(e.target.value)} />
        {err && <p data-testid="reset-error" className="text-sm text-rose-600">{err}</p>}
        <button data-testid="reset-submit-btn" disabled={busy} className={btnCls}>{t("reset_submit")}</button>
      </form>
    </AuthShell>
  );
}
